// M-6 slice F: AI-report archive API (director-only).
// Searchable, paginated history of leader digests. Distinct from M-3's
// fetchAiReports (live "today" digest) in api/director.ts.
import { apiRequest } from './client'
import { MOCK, mockReportDetail, mockReports } from '../dev/mock'
import type { ArchiveReportDetail, ArchiveReportsResponse } from './types'

export interface ReportsFilter {
  q?: string
  kind?: string | null
  from?: string | null
  to?: string | null
  page?: number
}

export function fetchReports(f: ReportsFilter = {}): Promise<ArchiveReportsResponse> {
  if (MOCK) {
    // Single mock page; filter the fixtures client-side so search/kind demo.
    const q = (f.q || '').trim().toLowerCase()
    let reports = mockReports.reports
    if (f.kind) reports = reports.filter((r) => r.kind === f.kind)
    if (q) reports = reports.filter((r) => (r.title + r.excerpt).toLowerCase().includes(q))
    return Promise.resolve({ reports, total: reports.length })
  }
  const qs = new URLSearchParams()
  if (f.q && f.q.trim()) qs.set('q', f.q.trim())
  if (f.kind) qs.set('kind', f.kind)
  if (f.from) qs.set('from_', f.from)
  if (f.to) qs.set('to', f.to)
  if (f.page) qs.set('page', String(f.page))
  const s = qs.toString()
  return apiRequest<ArchiveReportsResponse>(`/api/miniapp/reports${s ? `?${s}` : ''}`)
}

export function fetchReportDetail(reportId: string): Promise<ArchiveReportDetail> {
  if (MOCK) return Promise.resolve(mockReportDetail)
  return apiRequest<ArchiveReportDetail>(`/api/miniapp/reports/${encodeURIComponent(reportId)}`)
}
